module.exports = {"work_time":"Work Time","work_time_recording":"Work Time Recording"};